import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Customers from "@/pages/Customers";
import Approvals from "@/pages/Approvals";
import AIInsights from "@/pages/AIInsights";
import Settings from "@/pages/Settings";
import { DepartmentPage, TeamDirectory } from "@/pages/DepartmentPage";
import Reports from "@/pages/Reports";
import { CRMDashboard } from "@/components/CRMDashboard";
import Portal from "@/pages/Portal";
import DesignerWorkspace from "@/pages/DesignerWorkspace";
import CommercialReview from "@/pages/CommercialReview";
import Finance from "@/pages/Finance";
import Procurement from "@/pages/Procurement";
import Operations from "@/pages/Operations";
import Handover from "@/pages/Handover";
import Service from "@/pages/Service";
import Workforce from "@/pages/Workforce";
import Marketing from "@/pages/Marketing";
import ControlTower from "@/pages/ControlTower";

function Protected({ children }) {
  const { status } = useAuth();
  if (status === "checking")
    return <div className="min-h-screen flex items-center justify-center text-sm text-neutral-400">Loading ILLAM…</div>;
  if (status === "guest") return <Navigate to="/login" replace />;
  return children;
}function AppRoutes() {
  const { status } = useAuth();
  return (
    <Routes>
      <Route path="/portal" element={<Portal />} />
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={status === "authed" ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/customers" element={<Protected><Customers /></Protected>} />
      <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
      <Route path="/ai" element={<Protected><AIInsights /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/crm" element={<Protected><DepartmentPage title="CRM — Leads" tabs={[{ value: "dashboard", label: "Dashboard", custom: <CRMDashboard /> }, { value: "leads", key: "leads", label: "Leads" }]} /></Protected>} />
      <Route path="/design" element={<Protected><DepartmentPage title="Design Studio" tabs={[{ value: "design", key: "design_items", label: "Design Tasks" }]} /></Protected>} />
      <Route path="/designer" element={<Protected><DesignerWorkspace /></Protected>} />
      <Route path="/commercial" element={<Protected><CommercialReview /></Protected>} />
      <Route path="/operations" element={<Protected><Operations /></Protected>} />
      <Route path="/handover" element={<Protected><Handover /></Protected>} />
      <Route path="/service" element={<Protected><Service /></Protected>} />
      <Route path="/workforce" element={<Protected><Workforce /></Protected>} />
      <Route path="/procurement" element={<Protected><Procurement /></Protected>} />
      <Route path="/finance" element={<Protected><Finance /></Protected>} />
      <Route path="/marketing" element={<Protected><Marketing /></Protected>} />
      <Route path="/control-tower" element={<Protected><ControlTower /></Protected>} />
      <Route path="/hr" element={<Protected><DepartmentPage title="HR" tabs={[{ value: "team", label: "Team Directory", custom: <TeamDirectory /> }, { value: "leave", key: "leave_requests", label: "Leave Requests" }]} /></Protected>} />
      <Route path="/price-master" element={<Protected><DepartmentPage title="Price Master" tabs={[{ value: "price", key: "price_items", label: "Price Items" }]} /></Protected>} />
      <Route path="/assets" element={<Protected><DepartmentPage title="Assets" tabs={[{ value: "assets", key: "assets", label: "Assets" }]} /></Protected>} />
      <Route path="/tickets" element={<Protected><DepartmentPage title="Tickets" tabs={[{ value: "tickets", key: "tickets", label: "Tickets" }]} /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
